import thumbnail from './thumbnail.svg'

export const sampleTrackedMeeting = {
  data: {
    end_time: '2025-01-13T21:45:00.000000Z',
    error: null,
    foreign_event_id: 'sample-foreign-event-id',
    foreign_event_provider: 'Calendly',
    location: 'https://calendly.zoom.us/j/99872571454',
    name: 'Client Project Strategy',
    start_time: '2025-01-13T21:40:00.000000Z',
    status: 'Completed',
    thumbnail,
    user_uuid: 'sample-user-uuid',
    uuid: 'sample-uuid'
  }
}

export const sampleSummary = {
  data: {
    summaries: [
      {
        name: 'Summary',
        kind: 'Markdown',
        value: 'Alex and Taylor discussed Acme’s Q2 priorities, focusing on streamlining the new client project. '
          + 'Taylor noticed delays caused by inconsistent internal handoffs. Alex suggested using a shared project '
          + 'tracker and offered to send templates after the call. They also discussed using Calendly to automate '
          + 'scheduling across teams. Taylor was interested in piloting the new scheduling approach with a regional '
          + 'team. Next steps: confirm pilot details and schedule a follow-up in two weeks.',
        target_feedback_thumb: 0,
        target_status: 'COMPLETED'
      },
      {
        name: 'Action Items',
        kind: 'Markdown',
        value: '**Alex Smith**\n - Gather feedback from early users to refine summary accuracy.\n - Identify key '
          + 'usability issues and propose potential improvements.\n\n**Taylor Jones**\n - Send pricing details to '
          + 'Jessica\n - Customize a tailored proposal based on Jessica\'s pain points\n - Contact Ryan about case studies',
        target_uuid: 'd53c3cef-8cf8-4651-9b2e-bdb4404f4d05',
        target_feedback_thumb: 0,
        target_status: 'COMPLETED'
      },
      {
        name: 'Discussion',
        kind: 'Markdown',
        value: '**Discussion Highlights**\n\nAlex and Taylor explored Acme’s Q2 priorities, especially around the new client '
          + 'project. Taylor flagged internal handoff issues as a source of delay. Alex recommended '
          + 'using a shared project tracker and offered to send sample templates. They reviewed how Calendly could '
          + 'streamline scheduling across departments. Taylor showed interest in piloting this approach with a regional '
          + 'team. They agreed on next steps: reviewing the tracker, confirming the pilot team, '
          + 'and scheduling a follow-up.',
        target_uuid: '1ecd2de6-7bc7-4a8b-8158-bbcce65cc4a0',
        target_feedback_thumb: 0,
        target_status: 'COMPLETED'
      }
    ],
  }
}
